import { useEffect, useRef, useState } from 'react'
import { toast } from 'sonner'
import { useCurrentBusiness } from '~/entities/business/model/use-business'
import { creditPackReturn } from '~/entities/credits/lib/credit-pack-return'
import { useConfirmCreditPack } from '~/entities/credits/model/use-credit-pack'
import { formatCredits } from '~/entities/subscription/plans'
import * as m from '~/paraglide/messages'

/** Books a pack the moment Checkout sends the buyer back, on whichever dashboard page they left. */
export function CreditPackReturn() {
  const [sessionId] = useState(() => creditPackReturn(window.location.href).sessionId)
  const { data: business } = useCurrentBusiness()
  const businessId = business?.id
  const { mutate: confirm } = useConfirmCreditPack()
  const started = useRef(false)

  useEffect(() => {
    if (!sessionId || !businessId || started.current) return
    started.current = true
    window.history.replaceState(
      window.history.state,
      '',
      creditPackReturn(window.location.href).cleanPath,
    )
    confirm(
      { businessId, sessionId },
      {
        onSuccess: ({ paid, credits }) => {
          if (paid) toast.success(m.creditPackBooked({ credits: formatCredits(credits) }))
          else toast.info(m.creditPackPending())
        },
        onError: () => {
          toast.error(m.creditPackConfirmFailed())
        },
      },
    )
  }, [sessionId, businessId, confirm])

  return null
}
